import { SearchX } from "lucide-react";

export function NoResultsState() {
  return (
    <section className="no-results">
      <SearchX size={26} aria-hidden="true" />
      <h2>No matching sources</h2>
      <p>Try a broader term or remove one of the active filters.</p>
    </section>
  );
}
